export const tournaments = [
    {
        id: 1,
        name: "Community Cup 2024",
        date: "2024-11-23",
        location: "TBA, Mumbai",
        ageGroup: "U15",
        skillLevel: "Intermediate",
        type: "Amateur",
        registrationFee: "₹3600",
        organizer: "The House of J",
        description: "The biggest inter-parish tournament in the town",
        image: "https://scontent.fbom2-2.fna.fbcdn.net/v/t39.30808-6/462293469_8571549426292018_774737348938324809_n.jpg?stp=dst-jpg_s1080x2048&_nc_cat=104&ccb=1-7&_nc_sid=aa7b47&_nc_ohc=7fH58p9zkcIQ7kNvgEFxBHD&_nc_zt=23&_nc_ht=scontent.fbom2-2.fna&_nc_gid=As8YAouvO51P9Nlj5uwsgKo&oh=00_AYAKmTg9Q78Q3pruyuIawlqcmnYSEJUSY_VhSQYxwR-VMg&oe=6715279D",
        maxParticipants: 32,
        currentParticipants: 6+3,
        prizes: ["₹30,000 for 1st place", "₹15,000 for 2nd place", "₹4ft Trophy for 3rd place"],
        contactEmail: "localcup2024@example.com",
        contactPhone: "+918983692590",
    },
    {
        id: 2,
        name: "Youth Football League Vasai 2024",
        date: "2024-11-09",
        location: "Vasai West, Mumbai",
        ageGroup: "U15",
        skillLevel: "Beginner",
        type: "Amateur",
        registrationFee: "₹5000",
        organizer: "Dominator Football",
        description: "Dominator Football presents 7th Youth Football League Vasai 2024. The tournament to be held on 9th & 10th November 2024. Held at Vasai West, Mumbai ⚽ This tournament will be conduct Under Age 15 years Boys and Under 16 years Girls 🧑‍🤝‍🧑 5 Main Players with 2 Substitutes in each Team 💪 Matches will be conduct on League cum Knockout basis 💰 Entry Fee for Under 15 Boys Rs. 2000 and Under 16 Girls Rs. 1600",
        image: "https://scontent.fbom2-2.fna.fbcdn.net/v/t39.30808-6/462001353_122159162642258663_7510650207977930974_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=aa7b47&_nc_ohc=w_daxeAvJAgQ7kNvgG6BLC-&_nc_zt=23&_nc_ht=scontent.fbom2-2.fna&_nc_gid=AtRoE6IA2W8fbq9q-peH8Ml&oh=00_AYCkF9lxEZl77PfIwNDW8ZC6GFyZJzuTCM4nbP-VORRR1Q&oe=67153507",
        maxParticipants: 25,
        currentParticipants: 18,
        prizes: ["Trophies for top 3 teams", "Medals for all participants"],
        contactEmail: "juniorleague@example.com",
        contactPhone: "+919876543210"
    },
    {
        id: 3,
        name: "Turf Football Tournament",
        date: "2024-010-27",
        location: "National Arena, Bangalore",
        ageGroup: "U17",
        skillLevel: "Advanced",
        type: "Semi-Pro",
        registrationFee: "₹2999",
        organizer: "PSZ",
        description: "We are excited to announce the First Edition Football Tournament! Kick off your passion! Join us for an unforgettable football tournament! on 27th October",
        image: "https://scontent.fbom2-2.fna.fbcdn.net/v/t39.30808-6/460721583_122178395564229621_2308066550060283592_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=aa7b47&_nc_ohc=Z-LdBbPclLcQ7kNvgFna14O&_nc_zt=23&_nc_ht=scontent.fbom2-2.fna&_nc_gid=AQzJ83sDbnLjc4UILMCaXYn&oh=00_AYCFhGu2XFxXY6FeCZpdZDh8VMF3s2EQSeul_-fzsx4DZw&oe=6715400E",
        maxParticipants: 32,
        currentParticipants: 28,
        prizes: ["₹50,000 for 1st place", "₹25,000 for 2nd place", "₹10,000 for 3rd place"],
        contactEmail: "prochallenge@example.com",
        contactPhone: "+91 8765432109"
    },
    {
        id: 4,
        name: "Super 8 Cup Season 1",
        date: "2024-09-15",
        location: "The Den, Ghitorni, Delhi",
        ageGroup: "U17",
        skillLevel: "Advanced",
        type: "Semi-Pro",
        registrationFee: "₹35000",
        organizer: "Vishal gusain",
        description: "Man of the Match (MOTM) in Every Game Special Gifts for Outstanding Performances",
        image: "https://media.hudle.in/events/4e7c43ab-5751-4934-a6ef-90e0a8c92dbc/photo?v=1724328501",
        maxParticipants: 32,
        currentParticipants: 28,
        prizes: ["Winners: ₹1 Lakh 💸 + Trophy 🏆 + Goodies Runners-up: ₹60,000 💸 + Trophy 🏆 + Goodies"],
        contactEmail: "vishalgusain76@gmail.com",
        contactPhone: "+91 8130185779"
    },
];

